import { queryOptions, useQuery } from '@tanstack/react-query'
import { authClient } from '@web/auth'

export const ORGANIZATIONS_QUERY_KEY = ['organizations'] as const

export const organizationsQuery = () =>
	queryOptions({
		queryKey: ORGANIZATIONS_QUERY_KEY,
		queryFn: async () => {
			const result = await authClient.organization.list()
			if (result.error) throw new Error(result.error.message ?? 'That list of organisations could not be loaded.')
			return result.data ?? []
		},
		retry: false,
	})

export function useOrganizations() {
	return useQuery(organizationsQuery())
}
